module.exports  = [
    {id: 0, volume: '0%'},
    {id: 5, volume: '5%'},
    {id: 10, volume: '10%'},
    {id: 15, volume: '15%'},
    {id: 20, volume: '20%'},
    {id: 25, volume: '25%'},
    {id: 30, volume: '30%'},
    {id: 35, volume: '35%'},
    {id: 40, volume: '40%'},
    {id: 45, volume: '45%'},
    {id: 50, volume: '50%'},
    {id: 55, volume: '55%'},
    {id: 60, volume: '60%'},
    {id: 65, volume: '65%'},
    {id: 70, volume: '70%'},
    {id: 75, volume: '75%'},
    {id: 80, volume: '80%'},
    {id: 85, volume: '85%'},
    {id: 90, volume: '90%'},
    {id: 95, volume: '95%'},
    {id: 100, volume: '100%'}
]